module.exports = __webpack_public_path__ + "static/triumph-8f9e8603f04abd6ec690c597d6f65c48.png";